import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import Custom from './custom'

const state = {
  commonObj: {
    hasDropdownLoaded: false,
    accommodationTypeList: [],
    serviceTypeList: [],
    gradeList: [],
    faqSetupList: [],
    evaluationNameList: [],
    trainingNameList: [],
    paymentType: Custom.paymentType,
    typeList: Custom.typeList,
    jobTypeList: Custom.jobTypeList,
    userPriceTypeList: Custom.userPriceTypeList,
    genderList: Custom.genderList,
    roomUserTypeList: Custom.roomUserTypeList,
    organizationTypeList: [],
    venueNameList: [],
    designationList: [],
    batchList: [],
    roomTypeList: [],
    circularMemoList: [],
    committeeDesignationList: [],
    committeeList: [],
    guestHouseList: [],
    registeredOrgList: [],
    docTypeList: []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
